<template>
  <v-container class="fill-height d-flex align-center justify-center">
    <v-card class="pa-6" max-width="500px" width="100%" elevation="8">
      <div class="text-center mb-6">
        <v-icon size="64" color="primary" class="mb-4">mdi-shield-lock</v-icon>
        <v-card-title class="text-h4 pa-0 mb-2">Welcome Back</v-card-title>
        <v-card-subtitle class="text-body-1">Sign in to your account</v-card-subtitle>
      </div>
      <v-card-text class="pa-0">
        <LoginForm />
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script setup lang="ts">
import LoginForm from "@/components/Auth/LoginForm.vue";
import { URLs } from "@/constants";
import { useAuthStore } from "@/stores/auth";
import { onMounted } from "vue";
import { useRouter } from "vue-router";

const authStore = useAuthStore();
const router = useRouter();

onMounted(() => {
  if (authStore.isAuthenticated) {
    router.push(URLs.PAGE_CUSTOMER_LIST);
  }
});
</script>

<style scoped>
.fill-height {
  min-height: 100vh;
}
</style>
